import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnOrganization } from '../organization';

export class SnIotDefender extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public organization: SnOrganization;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  public serialNumber: string;

  @Expose()
  public securityProfileName: string;

  @Expose()
  public eventTime: Date;

  @Expose()
  public violationId: string;

  @Expose()
  public behavior: string;

  @Expose()
  public eventType: string;

  @Expose()
  @Default('')
  public metricName: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
